import {
  IActiveExecution,
  IActiveExecutionRaw,
  toOptionalActiveExecution
} from './active-execution.interface';
import { IConversationMessageView, IConversationMessageViewRaw, toConversationMessageView } from './conversation-message-view.interface';
import { IConversationView, IConversationViewRaw, toConversationView } from './conversation-view.interface';

export interface IHistoryConversationRaw extends IConversationViewRaw {
  execution: IActiveExecutionRaw | null;
}

export interface IHistoryConversation extends IConversationView {
  execution: IActiveExecution | null;
}

export interface IConversationHistoryViewRaw {
  conversation: IHistoryConversationRaw;
  messages: IConversationMessageViewRaw[];
}

export interface IConversationHistoryView {
  conversation: IHistoryConversation;
  messages: IConversationMessageView[];
}

const toHistoryConversation = (raw: IHistoryConversationRaw): IHistoryConversation => ({
  ...toConversationView(raw),
  execution: toOptionalActiveExecution(raw.execution)
});

export const toConversationHistoryView = (raw: IConversationHistoryViewRaw): IConversationHistoryView => ({
  conversation: toHistoryConversation(raw.conversation),
  messages: raw.messages.map(toConversationMessageView)
});
